define('shared/remote/member/has',['$','shared/lib/RSVP', 'shared/page/apiVersion', 'shared/lib/console'], 
function ($, RSVP, getAPIVersion, console) {

    var membershipCache = {};
    var errNetwork = new Error('Network Failure');
    errNetwork.network = true;
    var URL = '/checkout/member/checkemail';
    // this is to check if user exist in old house
    // the reason we have this one is 
    // because above one is problematic
    // above one always return user does not exist when the corresponding
    // user is logged in
    var URL_CHECK_MAIL = '/checkout/member/emailexists';

    function sendRequest(email) {
        return new RSVP.Promise(function(resolve, reject){
            if (
                email == null ||
                email == false ||
                email.toString().indexOf('@') <= 0
            ) {
                reject();
                return;
            }

            var dfd = $.ajax({
                url: URL,
                type: 'POST',
                data: {
                    email: email
                },
                dataType: 'json'
            });
            dfd.then( resolve, reject );
        });
    }

    function sendRequest2NewCheckMail(email) {
        return new RSVP.Promise(function(resolve, reject){
            if (
                email == null ||
                email == false ||
                email.toString().indexOf('@') <= 0
            ) {
                reject();
                return;
            }

            var dfd = $.ajax({
                url: URL_CHECK_MAIL,
                type: 'GET',
                data: {
                    email: email
                },
                dataType: 'text'
            });
            dfd.then(function(text){
                if (text === 'true') {
                    resolve(true);
                } else {
                    resolve(false);
                }
            }, reject );
        });
    }

    function oldHouse(email) {
        return new RSVP.Promise(function(resolve, reject){
            var promise;

            if ( email in membershipCache && membershipCache[email] != null ) {
                promise = membershipCache[email];
            }
            else {
                promise = sendRequest(email);
                membershipCache[email] = promise;
            }

            promise.then(
                function(json){
                    var result = ( json && json.success === true ) ? true : false;
                    if ( result ) {
                        // user doesn't exit
                        resolve(false);
                    }
                    else {
                        // user exist
                        resolve(true);
                    }
                },
                function(err){
                    // remove from cache if request failed.
                    delete membershipCache[email];
                    console.log('Request error: ', err);
                    reject(errNetwork);
                }
            );
        });
    }

    function newHouse(email) {
        return new RSVP.Promise(function(resolve, reject){
            var promise;

            if (email in membershipCache && membershipCache[email] != null) {
                promise = membershipCache[email];
            }
            else {
                promise = sendRequest2NewCheckMail(email);
                membershipCache[email] = promise;
            }

            promise.then(
                resolve,
                function(err){
                    // remove from cache if request failed.
                    delete membershipCache[email];
                    console.log('Request error: ', err);
                    reject(errNetwork);
                }
            );
        });
    }

    return function( options ){

        var email = options.email;

        if ( email == null ) {
            throw 'Please specify the email address.';
        }

        return getAPIVersion()
            .then(function (apiVersion) {
                if (apiVersion === 'new-house') {
                    return newHouse(email);
                }
                else {
                    return oldHouse(email);
                }
            });
    };

});
